import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useDigitalCollections } from '../../../hooks/useDigitalCollections';
import { AnalyticsEventFeatures } from '../../../typings/analytics';
import { MESSAGES, PAGE_FUNCTION, PAGE_NAME, SUB_FUNCTION } from '../../../const/analytics';
import MainContext from '../../../Context';
import usePaymentFlowMachine from '../../../hooks/machines/usePaymentFlowMachine';
import useAnalyticsEventV2Creators from '../../../hooks/useAnalyticsEventV2Creators';
import { getAnalyticsMessageType } from '../../../machines/helpers';
import OneTimePaymentConfirmation from '../../molecules/PaymentModalStates/oneTimePayment/OneTimePaymentConfirmation';
import OneTimePaymentForm from '../../molecules/PaymentModalStates/oneTimePayment/OneTimePaymentForm';
import PaymentReview from '../../molecules/PaymentModalStates/oneTimePayment/PaymentReview';
import PaymentFailed from '../../molecules/PaymentModalStates/PaymentFailed';
const OneTimePayment = ({ resetTabFocus }) => {
    const [, oneTimePaymentActor] = usePaymentFlowMachine();
    const { createStartEventObject } = useAnalyticsEventV2Creators(AnalyticsEventFeatures.MAKE_A_PAYMENT);
    const { isSettlement, isCustomerAssistancePlan } = useDigitalCollections();
    const { triggerAnalyticsEvent } = useContext(MainContext);
    useEffect(() => {
        resetTabFocus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [oneTimePaymentActor.value]);
    useEffect(() => {
        if (!isSettlement) {
            const messageType = getAnalyticsMessageType(oneTimePaymentActor.context.apiMachineRef);
            const eventOptionsV1 = Object.assign(Object.assign({ pageFunction: PAGE_FUNCTION.MAKE_PAYMENT.PAYMENTS, pageSubFunction: SUB_FUNCTION.MAKE_PAYMENT.PAYMENT, pageName: PAGE_NAME.START }, (messageType && { messageType })), (isCustomerAssistancePlan && {
                message: MESSAGES.DCH.CAP
            }));
            const eventOptionsV2 = createStartEventObject();
            triggerAnalyticsEvent(eventOptionsV1, eventOptionsV2);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (oneTimePaymentActor.matches('edit')) {
        return _jsx(OneTimePaymentForm, {});
    }
    if (oneTimePaymentActor.matches('review') ||
        oneTimePaymentActor.matches('submitting')) {
        return _jsx(PaymentReview, {});
    }
    if (oneTimePaymentActor.matches('success')) {
        return _jsx(OneTimePaymentConfirmation, {});
    }
    if (oneTimePaymentActor.matches('error')) {
        return _jsx(PaymentFailed, {});
    }
    // default
    return null;
};
export default OneTimePayment;
